function createSlotchangeHandler(host, callback, options) {
  let timeoutId = null;
  const handler = (event) => {
    const slot = event.target;
    if (options?.slotName !== void 0) {
      const name = slot.name || "";
      if (name !== options.slotName) return;
    }
    const flatten = options?.flatten ?? false;
    const elements = slot.assignedElements({ flatten });
    const nodes = Array.from(slot.assignedNodes({ flatten }));
    const invoke = () => {
      callback({
        slot,
        elements,
        nodes,
        slotName: slot.name || void 0
      });
    };
    if (options?.debounce && options.debounce > 0) {
      if (timeoutId !== null) clearTimeout(timeoutId);
      timeoutId = setTimeout(invoke, options.debounce);
    } else {
      invoke();
    }
  };
  return {
    connect() {
      host.shadowRoot?.addEventListener("slotchange", handler);
      if (options?.immediate) {
        const flatten = options.flatten ?? false;
        const slots = host.shadowRoot?.querySelectorAll("slot") ?? [];
        slots.forEach((slot) => {
          const name = slot.name || "";
          if (options.slotName !== void 0 && name !== options.slotName) {
            return;
          }
          callback({
            slot,
            elements: slot.assignedElements({ flatten }),
            nodes: Array.from(slot.assignedNodes({ flatten })),
            slotName: slot.name || void 0
          });
        });
      }
    },
    disconnect() {
      host.shadowRoot?.removeEventListener("slotchange", handler);
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  };
}
class SlotchangeController {
  constructor(host, configs) {
    this.host = host;
    this.configs = configs;
    this.handlers = [];
    host.addController(this);
  }
  hostConnected() {
    for (const config of this.configs) {
      const handler = createSlotchangeHandler(
        this.host,
        config.callback,
        { ...config.options, slotName: config.slotName }
      );
      handler.connect();
      this.handlers.push(handler);
    }
  }
  hostDisconnected() {
    this.handlers.forEach((h) => h.disconnect());
    this.handlers = [];
  }
}
export {
  SlotchangeController,
  createSlotchangeHandler
};
//# sourceMappingURL=slot-events.js.map
